export const INIT_CONSENTS = 'INIT_CONSENTS';
export const CONSENT_SUBMITTED = 'CONSENT_SUBMITTED';
export const ACCEPT_CONSENT = 'ACCEPT_CONSENT';
export const CONSENT_REJECTED = 'CONSENT_REJECTED';
